import React from "react";

const CompanyProfile = ({
    companyValues,
    handleCompanyInputChange,
    companySaving,
    companyLoading,
    companyId,
}) => {
    return (
        <div className="dc-dashboardboxcontent" style={{ padding: "30px" }}>
            {companyLoading ? (
                <div className="text-center p-5">
                    <div className="spinner-border" role="status"></div>
                </div>
            ) : (
                <div>
                    {!companyId && (
                        <div className="alert alert-info" role="alert" style={{ fontSize: "14px", marginBottom: "20px" }}>
                            No company record linked yet. Fill in the details below to create your insurance provider profile.
                        </div>
                    )}
                    <div className="row justify-content-lg-end" style={{ rowGap: "24px" }}>
                        <div className="col-12 col-lg-10 col-xl-9 ms-lg-auto">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Company Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="company_name"
                                        value={companyValues.company_name}
                                        onChange={handleCompanyInputChange}
                                        placeholder="e.g. AlphaCare Insurance"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Legal Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="legal_name"
                                        value={companyValues.legal_name}
                                        onChange={handleCompanyInputChange}
                                        placeholder="Registered legal entity"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Primary Email *</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        value={companyValues.email}
                                        onChange={handleCompanyInputChange}
                                        placeholder="support@yourcompany.com"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Primary Phone</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="phone"
                                        value={companyValues.phone}
                                        onChange={handleCompanyInputChange}
                                        placeholder="Contact number"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Support Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="support_email"
                                        value={companyValues.support_email}
                                        onChange={handleCompanyInputChange}
                                        placeholder="helpdesk@yourcompany.com"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Support Phone</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="support_phone"
                                        value={companyValues.support_phone}
                                        onChange={handleCompanyInputChange}
                                        placeholder="Customer care number"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Website</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="website"
                                        value={companyValues.website}
                                        onChange={handleCompanyInputChange}
                                        placeholder="https://"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Status</label>
                                    <select
                                        className="form-control"
                                        name="status"
                                        value={companyValues.status}
                                        onChange={handleCompanyInputChange}
                                        disabled={companySaving}
                                    >
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                        <option value="pending">Pending</option>
                                    </select>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Registration Number</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="registration_number"
                                        value={companyValues.registration_number}
                                        onChange={handleCompanyInputChange}
                                        placeholder="CIN / registration"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">License Number</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="license_number"
                                        value={companyValues.license_number}
                                        onChange={handleCompanyInputChange}
                                        placeholder="IRDA or other license"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">GST Number</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="gst_number"
                                        value={companyValues.gst_number}
                                        onChange={handleCompanyInputChange}
                                        placeholder="GSTIN"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label className="form-label">Office Address</label>
                                    <textarea
                                        className="form-control"
                                        name="address"
                                        rows="3"
                                        value={companyValues.address}
                                        onChange={handleCompanyInputChange}
                                        placeholder="Head office address"
                                        disabled={companySaving}
                                    ></textarea>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">City</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="city"
                                        value={companyValues.city}
                                        onChange={handleCompanyInputChange}
                                        placeholder="City"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">State</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="state"
                                        value={companyValues.state}
                                        onChange={handleCompanyInputChange}
                                        placeholder="State"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Country</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="country"
                                        value={companyValues.country}
                                        onChange={handleCompanyInputChange}
                                        placeholder="Country"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Postal Code</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="postal_code"
                                        value={companyValues.postal_code}
                                        onChange={handleCompanyInputChange}
                                        placeholder="Postal code"
                                        disabled={companySaving}
                                    />
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label className="form-label">Internal Notes</label>
                                    <textarea
                                        className="form-control"
                                        name="notes"
                                        rows="3"
                                        value={companyValues.notes}
                                        onChange={handleCompanyInputChange}
                                        placeholder="Additional context for your team"
                                        disabled={companySaving}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CompanyProfile;

